module.exports = __webpack_public_path__ + "static/img/6.799afbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/companyLogo-f/6.jpg
// module id = yzGQ
// module chunks = 0